<!--suppress UnterminatedStatementJS, JSUnresolvedVariable -->
<template>
  <div class="[ c-cookie-banner ]" v-bind:id="bannerId" v-bind:style="inlineStyles">
    <div class="[ c-cookie-banner__overlay ]"></div>
    <div v-if="landingPage" class="[ c-cookie-banner__body ]">
      <logo :image-path="logo"/>
      <h1 class="[ c-cookie-banner__headline ]" v-html="$t('banner.headline')"/>
      <p class="[ c-cookie-banner__text ]" v-html="$t('banner.description')"/>
      <ul v-if="configLoaded" class="[ c-cookie-banner__checkbox-list ]">
            <cookie-list  :key="index" v-for="(cookieData, cookieName, index) in this.necessaryConfig"
                     :ref="cookieName"
                     :cookie-list="cookieData"
                     :show-details="isDetails"
                     :language="language"
                     :list-type="cookieName"
            />
      </ul>

      <button-area
        v-on:submit_selected="submitCookies()"
        v-on:activate_all="submitAllCookies()"
        v-on:show_details="isDetails = !isDetails"
      />
      <cookie-footer v-on:goto_info="toggleInfoPage()"/>
    </div>
    <privacy-terms v-if="informationPage"
                   v-on:goBack="toggleInfoPage()"
                   :language="language"
                   :privacy-content-path="privacyContentPath"/>
  </div>
</template>
<script>
/* eslint-disable no-prototype-builtins,no-eval */

import CookieList from './List/CookieList'
import ButtonArea from './Partials/ButtonArea'
import CookieFooter from './Partials/Footer'
import PrivacyTerms from './Partials/PrivacyTerms'
import Logo from './Partials/Logo'

import ConfigRepository from '../../repositories/ConfigRepository'
import CookieService from '../../services/CookieService'
import LocalStorageService from '../../services/LocalStorageService'
import _ from 'lodash'

export default {
  name: 'CookieBanner',
  components: {
    CookieList: CookieList,
    ButtonArea: ButtonArea,
    CookieFooter: CookieFooter,
    PrivacyTerms: PrivacyTerms,
    Logo: Logo
  },
  async beforeMount () {
    if (!this.settingsSet) {
      ConfigRepository.fetchConfig(this.cookieConfig)
        .then(response => {
          if (response) {
            this.config = response.data
            this.formatConfig()
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error('<nsd-cookie-banner> Could not fetch given Config JSON: ' + error.message)
        })
    }
  },
  async mounted () {
    setTimeout(() => {
      if (this.settings !== null) {
        this.importSettings(this.settings)
        this.settingsSet = true
      }
    }, 150)
  },
  props: {
    cookieConfig: String,
    lang: String,
    logo: String,
    bannerId: String,
    inlineStyles: String,
    translationPath: String,
    privacyContentPath: String,
    settings: { type: Object, default: null }
  },
  data: function () {
    return {
      config: {},
      language: this.lang,
      isDetails: false,
      landingPage: true,
      informationPage: false,
      importedSettings: null,
      settingsSet: false,
      necessaryConfig: {},
      configLoaded: false
    }
  },
  computed: {
    allCheckedCookies: function () {
      const allCheckedCookies = []
      _.each(this.$refs, (cookieList, cookieListType) => {
        const checkedCookies = cookieList[0].checkedCookies
        if (checkedCookies) {
          _.each(checkedCookies, (cookie) => {
            allCheckedCookies.push(cookie)
          })
        }
      })
      return { ...allCheckedCookies }
    },
    allCookiesList: function () {
      const allCookies = []
      _.each(this.necessaryConfig, (cookieListData) => {
        allCookies.push(...cookieListData)
      })
      return { ...allCookies }
    },
    serializedCookieSettings: function () {
      return JSON.stringify(this.allCheckedCookies)
    }
  },
  methods: {
    /**
       * Evaluate JavaScript to run deactivation Scripts
       */
    deactivateAllCookies: function () {
      _.each(this.config, (cookieData) => {
        CookieService.invalidateCookieJsByList(cookieData)
      })
    },
    /**
       * set all cookies (Functional and Marketing) in Child Components
       */
    submitAllCookies: function () {
      _.each(this.necessaryConfig, (cookieData, cookieName) => {
        this.$refs[cookieName][0].checkedCookies = this.necessaryConfig[cookieName]
      })
      // Let User see, all categories are checked before fading out the Banner
      setTimeout(() => this.submitCookies(), 250)
    },
    /**
       * Submit all selected Cookies
       */
    submitCookies: function () {
      CookieService.clearCookieByList(this.allCookiesList)
      this.deactivateAllCookies()
      CookieService.addCookieByList(this.allCheckedCookies)
      LocalStorageService.setCookieSettings(this.serializedCookieSettings)
      this.$emit('settingsSet')
      this.rerenderComponent()
    },
    importSettings: function (cookieSettings) {
      CookieService.addCookieByList(cookieSettings)
      this.checkImportedCookies(cookieSettings)
    },
    checkImportedCookies: function (cookieSettings) {
      const objFilterFn = function (item, cookie) {
        return _.isEqual(item, cookie) ? item : false
      }

      _.each(cookieSettings, (cookie) => {
        _.each(this.$refs, (component, key) => {
          if (_.some(this.necessaryConfig[key], item => objFilterFn(item, cookie)) && key !== 'essential') {
            this.$refs[key][0].checkedCookies.push(cookie)
          }
        })
      })
    },
    rerenderComponent: function () {
      this.$emit('forceRerender', LocalStorageService.getCookieSettings())
    },
    /**
       * Toggle Data Protection Terms and Landing Page
       */
    toggleInfoPage: function () {
      this.informationPage = !this.informationPage
      this.landingPage = !this.landingPage

      if (this.landingPage === true) {
        this.rerenderComponent()
      }
    },
    /**
     * Create necessaryConfig without dataProtection entry
     */
    formatConfig: function () {
      _.each(this.config, (cookieData, cookieName) => {
        if (cookieData[0]) {
          this.necessaryConfig[cookieName] = cookieData
        }
      })
      this.configLoaded = true
    }
  }
}
</script>
<style lang="scss">
  @import '~@/assets/scss/_main.scss';
</style>
